import { FC } from "react";
import { Typography } from "@mui/material";
import { ResourceExplorerCostsDateDetails } from "@/services/cloudchipr.api";
import { money } from "@/utils/numeral/money";
import { BillingExplorerWidgetNoDataCell } from "@/components/pages/dashboard/components/widgets/billing-explorer-widget/components/chart/ag-table/cells/BillingExplorerWidgetNoDataCell";

interface BillingExplorerWidgetPrevCostCellProps {
  dates?: ResourceExplorerCostsDateDetails;
  cost?: number | null;
}

export const BillingExplorerWidgetPrevCostCell: FC<
  BillingExplorerWidgetPrevCostCellProps
> = ({ cost, dates }) => {
  if (cost === null) {
    return <BillingExplorerWidgetNoDataCell alignment="right" dates={dates} />;
  }

  return (
    <Typography variant="body2" align="right" pr={10}>
      {money(cost)}
    </Typography>
  );
};
